var map = {
	"./1.png": 96,
	"./2.png": 97,
	"./3.png": 98,
	"./4.png": 99,
	"./Bg-1.png": 100,
	"./Bg-2.png": 101,
	"./Bg-3.png": 102,
	"./Bg-4.png": 103,
	"./Bg.png": 104,
	"./Image-1.png": 105,
	"./Image-2.png": 106,
	"./Image-3.png": 107,
	"./Image-4.png": 108,
	"./Image-5.png": 43,
	"./Image-6.png": 44,
	"./Image-7.png": 45,
	"./Image-8.png": 46,
	"./Image.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;